import { ACCEPTED_TYPES_AS_CONST, USER_READABLE_ACCEPTED_TYPES } from '@/utils/isAcceptedVideoType';

export type AcceptedVideoTypes = typeof USER_READABLE_ACCEPTED_TYPES[number];
export type MimeTypeOptions = typeof ACCEPTED_TYPES_AS_CONST[number];

const getMimeTypeFromFileExtension = (fileType: AcceptedVideoTypes): MimeTypeOptions => {
  switch (fileType) {
    case 'mov':
      return 'video/quicktime';
    case 'm4v':
      return 'video/x-m4v';
    case 'mp4':
      return 'video/mp4';
    case 'webm':
    default:
      return 'video/webm';
  }
};

export default getMimeTypeFromFileExtension;
